//import { roundPercentage, roundPrice, roundToInteger } from '@hero/core';
import { z } from 'zod';

const roundPercentage = (value: number) => value;
const roundPrice = (value: number) => value;
const roundToInteger = (value: number) => value;
const numSchema = z.coerce.number();

export const integerSchema = numSchema.transform(value => {
  return roundToInteger(value);
});

export const quantitySchema = numSchema.min(0);

export const floatNumSchema = numSchema;

export const positiveIntegerSchema = numSchema.min(0).transform(value => {
  return roundToInteger(value);
});

/**
 * price schema validates price and rounded.
 *
 * `Allows positive & negative `
 */
export const priceSchema = z.coerce.number().transform(value => {
  return roundPrice(value);
});
export const nonZeroPriceSchema = z.coerce
  .number()
  .min(1)
  .transform(value => {
    return roundPrice(value);
  });
/**
 * price schema validates that the price is higher than `0` and rounded
 */
export const pricePositiveSchema = z.coerce
  .number()
  .min(0)
  .transform(value => {
    return roundPrice(value);
  });
/**
 * validates percentages as 0.10 = 10% and rounds them
 */
export const percentageSchema = z.coerce
  .number()
  .min(0)
  .max(1)
  .transform(value => {
    return roundPercentage(value);
  });
/**
 * validates percentages as 0.10 = 10% and rounds them.
 *
 * this accept negative percentage
 */
export const percentageNegativeSchema = z.coerce
  .number()
  .min(-1) // -100%
  .max(1) // 100%
  .transform(value => {
    return roundPercentage(value);
  });

/** You should use this for scoring any thing.
 *
 * - 0 = means did NOT happen
 * - 1 = means 1% or the lowest possible outcome
 * - 10 = means 100% or the full mark
 */
export const scoreSchema = z.coerce.number().min(0).max(10);
